import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../api/axiosConfig";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../../index.css";
import MainLayout from "../MainLayout";
import QZTrayService from "../../api/qz-tray-service";

const Visita = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const cliente = location.state?.cliente;
  const sucursales = location.state?.sucursales;
  if (!cliente) {
    navigate("/dashboard/clientes");
  }

  const [dificultadLejos, setDificultadLejos] = useState("No");
  const [dificultadCerca, setDificultadCerca] = useState("No");
  const [dolorCabeza, setDolorCabeza] = useState("No");
  const [irritacion, setIrritacion] = useState("No");
  const [diabetes, setDiabetes] = useState("No");
  const [hipertension, setHipertension] = useState("No");

  // Estado para la tabla de prescripción
  const [esfOd, setEsfOd] = useState("");
  const [esfOi, setEsfOi] = useState("");
  const [cilOd, setCilOd] = useState("");
  const [cilOi, setCilOi] = useState("");
  const [ejeOd, setEjeOd] = useState("");
  const [ejeOi, setEjeOi] = useState("");
  const [addOd, setAddOd] = useState("");
  const [addOi, setAddOi] = useState("");
  const [avOd, setAvOd] = useState("");
  const [avOi, setAvOi] = useState("");
  const [cvOd, setCvOd] = useState("");
  const [cvOi, setCvOi] = useState("");
  const [retinosOd, setRetinosOd] = useState("");
  const [retinosOi, setRetinosOi] = useState("");
  const [queratoOd1, setQueratoOd1] = useState("");
  const [queratoOd2, setQueratoOd2] = useState("");
  const [queratoOd3, setQueratoOd3] = useState("");
  const [queratoOi1, setQueratoOi1] = useState("");
  const [queratoOi2, setQueratoOi2] = useState("");
  const [queratoOi3, setQueratoOi3] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [color, setColor] = useState("");
  const [lenteContactoDes, setLenteContactoDes] = useState("");
  const [diData, setDiData] = useState("");
  const [aoData, setAoData] = useState("");
  const [optometrista, setOptometrista] = useState("FLAVIANO PELAYO SALAZAR");
  //const [cedula, setCedula] = useState("9330082");
  const [cedula, setCedula] = useState("");
  const [fotos, setFotos] = useState([]);
  const [nombreIdentificador, setNombreIdentificador] = useState("");
  const [historialVisitas, setHistorialVisitas] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  const [visitaSeleccionadaId, setVisitaSeleccionadaId] = useState(null);
  const [visitaSeleccionadaMeta, setVisitaSeleccionadaMeta] = useState(null);

  const handleFileChange = (e) => {
    setFotos([...e.target.files]);
  };

  // Cargar historial de visitas al montar el componente
  useEffect(() => {
    if (cliente?.id) {
      cargarHistorialVisitas();
    }
    
    // Conectar con QZ Tray cuando el componente se monte
    QZTrayService.connect();
    
    return () => {
      // Desconectar QZ Tray cuando el componente se desmonte
      QZTrayService.disconnect();
    };
  }, [cliente]);

  const cargarHistorialVisitas = async () => {
    setCargandoHistorial(true);
    try {
      const response = await axios.get(`/HistorialVisitas/${cliente.id}`);
      setHistorialVisitas(response.data || []);
    } catch (error) {
      console.error("Error al cargar historial de visitas:", error);
    } finally {
      setCargandoHistorial(false);
    }
  };

  const cargarVisitaPorId = async (idVisita) => {
    try {
      const response = await axios.get(`/visitas/porId/${idVisita}`);
      if (response.data.success && response.data.data) {
        const visita = response.data.data;
        setVisitaSeleccionadaId(idVisita);
        setVisitaSeleccionadaMeta({
          IdVisita: idVisita,
          CreateDate: visita.CreateDate || visita.createDate || null,
          NombreIdentificador: visita.NombreIdentificador || visita.nombreIdentificador || "",
        });
        
        // Debug: ver qué datos estamos recibiendo
        console.log("Datos de la visita recibidos:", visita);
        
        // Rellenar todos los campos con los datos de la visita
        setDificultadLejos(visita.DificultadLejos || visita.dificultadLejos || "No");
        setDificultadCerca(visita.DificultadCerca || visita.dificultadCerca || "No");
        setDolorCabeza(visita.DolorCabeza || visita.dolorCabeza || "No");
        setIrritacion(visita.Irritacion || visita.irritacion || "No");
        setDiabetes(visita.Diabetes || visita.diabetes || "No");
        setHipertension(visita.Hipertension || visita.hipertension || "No");
        setEsfOd(visita.EsfOd || visita.esfOd || "");
        setEsfOi(visita.EsfOi || visita.esfOi || "");
        setCilOd(visita.CilOd || visita.cilOd || "");
        setCilOi(visita.CilOi || visita.cilOi || "");
        setEjeOd(visita.EjeOd || visita.ejeOd || "");
        setEjeOi(visita.EjeOi || visita.ejeOi || "");
        setAddOd(visita.AddOd || visita.addOd || "");
        setAddOi(visita.AddOi || visita.addOi || "");
        setAvOd(visita.AvOd || visita.avOd || "");
        setAvOi(visita.AvOi || visita.avOi || "");
        setCvOd(visita.CvOd || visita.cvOd || "");
        setCvOi(visita.CvOi || visita.cvOi || "");
        setRetinosOd(visita.RetinosOd || visita.retinosOd || "");
        setRetinosOi(visita.RetinosOi || visita.retinosOi || "");
        setQueratoOd1(visita.QueratoOd1 || visita.queratoOd1 || "");
        setQueratoOd2(visita.QueratoOd2 || visita.queratoOd2 || "");
        setQueratoOd3(visita.QueratoOd3 || visita.queratoOd3 || "");
        setQueratoOi1(visita.QueratoOi1 || visita.queratoOi1 || "");
        setQueratoOi2(visita.QueratoOi2 || visita.queratoOi2 || "");
        setQueratoOi3(visita.QueratoOi3 || visita.queratoOi3 || "");
        setObservaciones(visita.Observaciones || visita.observaciones || "");
        setColor(visita.Color || visita.color || "");
        setLenteContactoDes(visita.LenteContactoDes || visita.lenteContactoDes || "");
        setDiData(visita.DiData || visita.diData || "");
        setAoData(visita.AoData || visita.aoData || "");
        setOptometrista(visita.Optometrista || visita.optometrista || "FLAVIANO PELAYO SALAZAR");
        setCedula(visita.Cedula || visita.cedula || "");
        setNombreIdentificador(visita.NombreIdentificador || visita.nombreIdentificador || "");

      }
    } catch (error) {
      console.error("Error al cargar la visita:", error);
      Swal.fire("Error", "No se pudo cargar la visita", "error");
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return "";
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const imprimirNotaVisita = async (idVisita) => {
    try {
      Swal.fire({
        title: "Generando nota...",
        text: "Por favor espere",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Generar el screenshot de la nota
      const response = await axios.post(`/visitas/NotaVentaScreenshot/${idVisita}`);
      
      if (response.data.success && response.data.notaLabUrl) {
        const imgUrl = response.data.notaLabUrl;
        console.log("URL de la nota:", imgUrl);
        // Prepara los datos para ser enviados a QZ Tray
        const data = [
          {
            type: "image",
            format: "url",
            data: imgUrl,
          },
        ];

        // Llama al servicio de QZ Tray para imprimir el ticket
        const success = await QZTrayService.printData(data);

        Swal.close();

        if (success) {
          Swal.fire(
            "Éxito",
            "Nota enviada a impresión correctamente",
            "success"
          );
        } else {
          Swal.fire(
            "Error",
            "No se pudo imprimir, recargue la página e intente de nuevo, si el error persiste contacte a soporte.",
            "error"
          );
        }
      } else {
        Swal.close();
        Swal.fire("Error", "No se pudo generar la nota", "error");
      }
    } catch (error) {
      console.error("Error al imprimir la nota:", error);
      Swal.close();
      Swal.fire(
        "Error",
        "Ocurrió un error inesperado al intentar imprimir la nota",
        "error"
      );
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const branchId = parseInt(localStorage.getItem("branchId"), 10);
    const sucursal = sucursales.find((suc) => suc.id === branchId);
    const requestData = new FormData();

    requestData.append("idCliente", cliente.id);
    requestData.append("nombreCliente", cliente.nombreCompleto);
    requestData.append("idSucursal", localStorage.getItem("branchId"));
    requestData.append("nombreSucursal", sucursal.direccion);
    requestData.append("dificultadLejos", dificultadLejos);
    requestData.append("dificultadCerca", dificultadCerca);
    requestData.append("dolorCabeza", dolorCabeza);
    requestData.append("irritacion", irritacion);
    requestData.append("diabetes", diabetes);
    requestData.append("hipertension", hipertension);
    requestData.append("esfOd", esfOd);
    requestData.append("esfOi", esfOi);
    requestData.append("cilOd", cilOd);
    requestData.append("cilOi", cilOi);
    requestData.append("ejeOd", ejeOd);
    requestData.append("ejeOi", ejeOi);
    requestData.append("addOd", addOd);
    requestData.append("addOi", addOi);
    requestData.append("avOd", avOd);
    requestData.append("avOi", avOi);
    requestData.append("cvOd", cvOd);
    requestData.append("cvOi", cvOi);
    requestData.append("retinosOd", retinosOd);
    requestData.append("retinosOi", retinosOi);
    requestData.append("queratoOd1", queratoOd1);
    requestData.append("queratoOd2", queratoOd2);
    requestData.append("queratoOd3", queratoOd3);
    requestData.append("queratoOi1", queratoOi1);
    requestData.append("queratoOi2", queratoOi2);
    requestData.append("queratoOi3", queratoOi3);
    requestData.append("observaciones", observaciones);
    requestData.append("color", color);
    requestData.append("lenteContactoDes", lenteContactoDes);
    requestData.append("diData", diData);
    requestData.append("aoData", aoData);
    requestData.append("optometrista", optometrista);
    requestData.append("cedula", cedula);
    requestData.append("nombreIdentificador", nombreIdentificador);
    requestData.append("createDate", new Date().toISOString()); // Fecha actual en formato ISO

    fotos.forEach((foto, index) => {
      requestData.append("fotos", foto); // Asegúrate de que el nombre del campo es 'fotos'
    });
    try {
      const isUpdate = Boolean(visitaSeleccionadaId);
      const url = isUpdate ? `/visitas/actualizar/${visitaSeleccionadaId}` : "/visitas/crear";
      const response = await axios.put(url, requestData, {
        headers: {
          name: localStorage.getItem("name"),
          lastname: localStorage.getItem("lastName"),
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.success) {
        // Limpiar el formulario
        setDificultadLejos("No");
        setDificultadCerca("No");
        setDolorCabeza("No");
        setIrritacion("No");
        setDiabetes("No");
        setHipertension("No");
        setEsfOd("");
        setEsfOi("");
        setCilOd("");
        setCilOi("");
        setEjeOd("");
        setEjeOi("");
        setAddOd("");
        setAddOi("");
        setAvOd("");
        setAvOi("");
        setCvOd("");
        setCvOi("");
        setRetinosOd("");
        setRetinosOi("");
        setQueratoOd1("");
        setQueratoOd2("");
        setQueratoOd3("");
        setQueratoOi1("");
        setQueratoOi2("");
        setQueratoOi3("");
        setObservaciones("");
        setColor("");
        setLenteContactoDes("");
        setDiData("");
        setAoData("");
        setOptometrista("FLAVIANO PELAYO SALAZAR");
        setCedula("");
        setNombreIdentificador("");
        setFotos([]);
        setVisitaSeleccionadaId(null);
        setVisitaSeleccionadaMeta(null);
        
        // Recargar el historial para mostrar la nueva visita arriba
        await cargarHistorialVisitas();
        
        Swal.fire({
          title: isUpdate ? "¡Visita actualizada correctamente!" : "¡Visita creada correctamente!",
          text: isUpdate
            ? "La visita fue actualizada y el historial se refrescó."
            : "La visita ha sido guardada y aparece en el historial. Puedes crear un pedido basado en esta visita.",
          icon: "success",
          confirmButtonText: "Aceptar",
        });
      } else {
        Swal.fire("Error", isUpdate ? "No se pudo actualizar la visita" : "No se pudo crear la visita", "error");
      }
    } catch (error) {
      console.error("Error al crear la visita:", error);
      Swal.fire("Error", visitaSeleccionadaId ? "Hubo un problema al actualizar la visita" : "Hubo un problema al crear la visita", "error");
    }
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString();
  }

  const inputTablaOptometria = {
    border: "1px solid #ced4da",
    borderRadius: "4px",
    borderColor: "#ced4da",
    width: "55px",
    padding: "3px",
    fontSize: "11px",
    textAlign: "center",
  };

  const tableHeaderStyle = {
    backgroundColor: "#007bff",
    color: "white",
    padding: "5px 3px",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "10px",
    border: "1px solid #0056b3",
  };

  const tableCellStyle = {
    padding: "5px 3px",
    textAlign: "center",
    border: "1px solid #dee2e6",
    backgroundColor: "#fff",
    fontSize: "11px",
  };

  return (
    <MainLayout>
      <div
        style={{
          color: "black",
          padding: "0 20px",
          display: "grid",
          width: "100%",
        }}
      >
        {/* Tabla de Historial de Visitas */}
        <div
          style={{
            marginBottom: "20px",
            padding: "0px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <h3
            style={{
              fontWeight: "700",
              fontSize: "20px",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            Historial de Visitas
          </h3>
          {cargandoHistorial ? (
            <p style={{ textAlign: "center" }}>Cargando historial...</p>
          ) : historialVisitas.length === 0 ? (
            <p style={{ textAlign: "center", color: "#666" }}>
              No hay visitas anteriores para este cliente
            </p>
          ) : (
            <div style={{ overflowX: "auto", width: "80%", margin: "0 auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  backgroundColor: "white",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#007bff", color: "white" }}>
                    <th
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        border: "1px solid #ddd",
                      }}
                    >
                      Fecha
                    </th>
                    <th
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        border: "1px solid #ddd",
                      }}
                    >
                      Nombre Identificador
                    </th>
                    <th
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        border: "1px solid #ddd",
                      }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {historialVisitas.map((visita) => (
                    <tr
                      key={visita.IdVisita}
                      style={{
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f0f0f0";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white";
                      }}
                    >
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        {formatearFecha(visita.CreateDate)}
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        {visita.NombreIdentificador || "Sin nombre"}
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                          width: "fit-content"
                        }}
                      >
                        <div style={{ display: "flex", gap: "8px", justifyContent: "center", flexWrap: "wrap" }}>
                          <button
                            type="button"
                            onClick={() => cargarVisitaPorId(visita.IdVisita)}
                            className="btn btn-sm btn-primary"
                            style={{
                              padding: "5px 15px",
                              fontSize: "13px",
                            }}
                          >
                            Ver
                          </button>
                          <button
                            type="button"
                            onClick={() => imprimirNotaVisita(visita.IdVisita)}
                            className="btn btn-sm btn-success"
                            style={{
                              padding: "5px 15px",
                              fontSize: "13px",
                            }}
                          >
                            Imprimir Nota
                          </button>
                          <button
                            type="button"
                            onClick={async () => {
                              try {
                                // Verificar que el cliente esté disponible antes de navegar
                                if (!cliente) {
                                  Swal.fire("Error", "No se encontró información del cliente", "error");
                                  return;
                                }
                                
                                // Cargar los datos completos de la visita seleccionada
                                const response = await axios.get(`/visitas/porId/${visita.IdVisita}`);
                                if (response.data.success && response.data.data) {
                                  const visitaData = response.data.data;
                                  
                                  // Preparar datos de la visita para pasar al formulario de pedido
                                  const datosVisita = {
                                    idVisita: visita.IdVisita,
                                    esfOd: visitaData.EsfOd || visitaData.esfOd || "",
                                    esfOi: visitaData.EsfOi || visitaData.esfOi || "",
                                    cilOd: visitaData.CilOd || visitaData.cilOd || "",
                                    cilOi: visitaData.CilOi || visitaData.cilOi || "",
                                    ejeOd: visitaData.EjeOd || visitaData.ejeOd || "",
                                    ejeOi: visitaData.EjeOi || visitaData.ejeOi || "",
                                    addOd: visitaData.AddOd || visitaData.addOd || "",
                                    addOi: visitaData.AddOi || visitaData.addOi || "",
                                    avOd: visitaData.AvOd || visitaData.avOd || "",
                                    avOi: visitaData.AvOi || visitaData.avOi || "",
                                    cvOd: visitaData.CvOd || visitaData.cvOd || "",
                                    cvOi: visitaData.CvOi || visitaData.cvOi || "",
                                    retinosOd: visitaData.RetinosOd || visitaData.retinosOd || "",
                                    retinosOi: visitaData.RetinosOi || visitaData.retinosOi || "",
                                    queratoOd1: visitaData.QueratoOd1 || visitaData.queratoOd1 || "",
                                    queratoOd2: visitaData.QueratoOd2 || visitaData.queratoOd2 || "",
                                    queratoOd3: visitaData.QueratoOd3 || visitaData.queratoOd3 || "",
                                    queratoOi1: visitaData.QueratoOi1 || visitaData.queratoOi1 || "",
                                    queratoOi2: visitaData.QueratoOi2 || visitaData.queratoOi2 || "",
                                    queratoOi3: visitaData.QueratoOi3 || visitaData.queratoOi3 || "",
                                    observaciones: visitaData.Observaciones || visitaData.observaciones || "",
                                    color: visitaData.Color || visitaData.color || "",
                                    lenteContactoDes: visitaData.LenteContactoDes || visitaData.lenteContactoDes || "",
                                    diData: visitaData.DiData || visitaData.diData || "",
                                    aoData: visitaData.AoData || visitaData.aoData || "",
                                    optometrista: visitaData.Optometrista || visitaData.optometrista || "",
                                    cedula: visitaData.Cedula || visitaData.cedula || "",
                                    nombreIdentificador: visitaData.NombreIdentificador || visitaData.nombreIdentificador || "",
                                    dificultadLejos: visitaData.DificultadLejos || visitaData.dificultadLejos || "No",
                                    dificultadCerca: visitaData.DificultadCerca || visitaData.dificultadCerca || "No",
                                    dolorCabeza: visitaData.DolorCabeza || visitaData.dolorCabeza || "No",
                                    irritacion: visitaData.Irritacion || visitaData.irritacion || "No",
                                    diabetes: visitaData.Diabetes || visitaData.diabetes || "No",
                                    hipertension: visitaData.Hipertension || visitaData.hipertension || "No",
                                  };
                                  
                                  console.log("Navegando a crear pedido con:", { cliente, sucursales, visitaData: datosVisita });
                                  
                                  navigate("/dashboard/crearPedido", {
                                    state: {
                                      cliente,
                                      sucursales,
                                      visitaData: datosVisita,
                                    },
                                  });
                                } else {
                                  Swal.fire("Error", "No se pudieron cargar los datos de la visita", "error");
                                }
                              } catch (error) {
                                console.error("Error al cargar la visita para crear pedido:", error);
                                Swal.fire("Error", "Ocurrió un error al cargar los datos de la visita", "error");
                              }
                            }}
                            className="btn btn-sm"
                            style={{
                              padding: "5px 15px",
                              fontSize: "13px",
                              backgroundColor: "#ffc107",
                              color: "#000",
                              border: "none",
                            }}
                          >
                            Nuevo Pedido
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <p
          style={{
            fontSize: "36px",
            textAlign: "center",
            fontWeight: "700",
            textDecoration: "underline",
          }}
        >
          {visitaSeleccionadaId ? "Editar Visita" : "Nueva Visita"}:{" "}
          <span style={{ fontWeight: "500" }}>{cliente?.nombreCompleto}</span>
        </p>
        {visitaSeleccionadaId ? (
          <div
            style={{
              maxWidth: "900px",
              margin: "0 auto 15px auto",
              padding: "10px 12px",
              border: "1px solid #ffc107",
              background: "#fff8e1",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ fontSize: "13px", fontWeight: 700 }}>
              Editando visita #{visitaSeleccionadaId}
              {visitaSeleccionadaMeta?.CreateDate ? (
                <span style={{ fontWeight: 500 }}>
                  {" "}
                  — {formatearFecha(visitaSeleccionadaMeta.CreateDate)}
                </span>
              ) : null}
              {visitaSeleccionadaMeta?.NombreIdentificador ? (
                <span style={{ fontWeight: 500 }}>
                  {" "}
                  — {visitaSeleccionadaMeta.NombreIdentificador}
                </span>
              ) : null}
            </div>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                setVisitaSeleccionadaId(null);
                setVisitaSeleccionadaMeta(null);
                // limpiar para crear nueva
                setDificultadLejos("No");
                setDificultadCerca("No");
                setDolorCabeza("No");
                setIrritacion("No");
                setDiabetes("No");
                setHipertension("No");
                setEsfOd("");
                setEsfOi("");
                setCilOd("");
                setCilOi("");
                setEjeOd("");
                setEjeOi("");
                setAddOd("");
                setAddOi("");
                setAvOd("");
                setAvOi("");
                setCvOd("");
                setCvOi("");
                setRetinosOd("");
                setRetinosOi("");
                setQueratoOd1("");
                setQueratoOd2("");
                setQueratoOd3("");
                setQueratoOi1("");
                setQueratoOi2("");
                setQueratoOi3("");
                setObservaciones("");
                setColor("");
                setLenteContactoDes("");
                setDiData("");
                setAoData("");
                setOptometrista("FLAVIANO PELAYO SALAZAR");
                setCedula("");
                setNombreIdentificador("");
                setFotos([]);
              }}
              style={{ whiteSpace: "nowrap" }}
            >
              Cancelar edición
            </button>
          </div>
        ) : null}
        <h3
          style={{ fontWeight: "700", textAlign: "center", paddingTop: "10px", fontSize: "24px", marginBottom: "15px" }}
        >
          Prescripción de Optometría
        </h3>
        <form
          onSubmit={handleSubmit}
          style={{
            padding: "10px 0",
            width: "100%",
          }}
        >
          {/* Información Básica */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 2fr 1fr",
              gap: "15px",
              marginBottom: "20px",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
            }}
          >
            <div>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                Nombre Identificador
              </label>
              <input
                type="text"
                value={nombreIdentificador}
                onChange={(e) => setNombreIdentificador(e.target.value)}
                placeholder="Ej: Lente de contacto"
                style={{
                  border: "1px solid #ced4da",
                  padding: "6px",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "13px",
                }}
              />
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                Optometrista
              </label>
              <input
                type="text"
                value={optometrista}
                onChange={(e) => setOptometrista(e.target.value)}
                placeholder="Nombre del optometrista"
                style={{
                  border: "1px solid #ced4da",
                  padding: "6px",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "13px",
                }}
              />
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                Cédula Profesional
              </label>
              <input
                type="text"
                value={cedula}
                onChange={(e) => setCedula(e.target.value)}
                placeholder="Cédula"
                style={{
                  border: "1px solid #ced4da",
                  padding: "6px",
                  borderRadius: "4px",
                  width: "100%",
                  maxWidth: "150px",
                  fontSize: "13px",
                }}
              />
            </div>
          </div>

          {/* Síntomas y Condiciones */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
              gap: "10px",
              marginBottom: "20px",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              maxWidth: "900px",
            }}
          >
            <div>
              <label style={{ fontWeight: "600", fontSize: "12px", display: "block", marginBottom: "5px" }}>
                Dificultad Lejos
              </label>
              <select
                value={dificultadLejos}
                onChange={(e) => setDificultadLejos(e.target.value)}
                required
                style={{ width: "100%", padding: "6px", borderRadius: "4px", fontSize: "13px", border: "1px solid #ced4da", maxWidth: "140px" }}
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "12px", display: "block", marginBottom: "5px" }}>
                Dificultad Cerca
              </label>
              <select
                value={dificultadCerca}
                onChange={(e) => setDificultadCerca(e.target.value)}
                required
                style={{ width: "100%", padding: "6px", borderRadius: "4px", fontSize: "13px", border: "1px solid #ced4da", maxWidth: "140px" }}
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "12px", display: "block", marginBottom: "5px" }}>
                Dolor de Cabeza
              </label>
              <select
                value={dolorCabeza}
                onChange={(e) => setDolorCabeza(e.target.value)}
                required
                style={{ width: "100%", padding: "6px", borderRadius: "4px", fontSize: "13px", border: "1px solid #ced4da", maxWidth: "140px" }}
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "12px", display: "block", marginBottom: "5px" }}>
                Irritación
              </label>
              <select
                value={irritacion}
                onChange={(e) => setIrritacion(e.target.value)}
                required
                style={{ width: "100%", padding: "6px", borderRadius: "4px", fontSize: "13px", border: "1px solid #ced4da", maxWidth: "140px" }}
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "12px", display: "block", marginBottom: "5px" }}>
                Diabetes
              </label>
              <select
                value={diabetes}
                onChange={(e) => setDiabetes(e.target.value)}
                required
                style={{ width: "100%", padding: "6px", borderRadius: "4px", fontSize: "13px", border: "1px solid #ced4da", maxWidth: "140px" }}
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "12px", display: "block", marginBottom: "5px" }}>
                Hipertensión
              </label>
              <select
                value={hipertension}
                onChange={(e) => setHipertension(e.target.value)}
                required
                style={{ width: "100%", padding: "6px", borderRadius: "4px", fontSize: "13px", border: "1px solid #ced4da", maxWidth: "140px" }}
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
            </div>
          </div>

          {/* Observaciones y Departamento en la misma fila */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            <div>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                Observaciones
              </label>
              <textarea
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                placeholder="Ingrese sus observaciones"
                style={{
                  border: "1px solid #ced4da",
                  padding: "8px",
                  borderRadius: "4px",
                  width: "100%",
                  minHeight: "80px",
                  fontSize: "13px",
                  resize: "vertical",
                }}
              />
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                Departamento / Empleado
              </label>
              <textarea
                value={color}
                onChange={(e) => setColor(e.target.value)}
                placeholder="Ingrese Departamento / Empleado"
                style={{
                  border: "1px solid #ced4da",
                  padding: "8px",
                  borderRadius: "4px",
                  width: "100%",
                  minHeight: "80px",
                  fontSize: "13px",
                  resize: "vertical",
                }}
              />
            </div>
          </div>

          {/* Graduación y Mediciones */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            {/* Prescripción */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "8px" }}>
              <h4 style={{ fontWeight: "700", fontSize: "13px", marginBottom: "8px", textAlign: "center", color: "#007bff" }}>
                Prescripción
              </h4>
              <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
                <thead>
                  <tr>
                    <th style={{ ...tableHeaderStyle, width: "40px" }}>Ojo</th>
                    <th style={tableHeaderStyle}>ESF</th>
                    <th style={tableHeaderStyle}>CIL</th>
                    <th style={tableHeaderStyle}>EJE</th>
                    <th style={tableHeaderStyle}>ADD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ ...tableCellStyle, fontWeight: "600", backgroundColor: "#e7f3ff" }}>OD</td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={esfOd} onChange={(e) => setEsfOd(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={cilOd} onChange={(e) => setCilOd(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={ejeOd} onChange={(e) => setEjeOd(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={addOd} onChange={(e) => setAddOd(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ ...tableCellStyle, fontWeight: "600", backgroundColor: "#e7f3ff" }}>OI</td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={esfOi} onChange={(e) => setEsfOi(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={cilOi} onChange={(e) => setCilOi(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={ejeOi} onChange={(e) => setEjeOi(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={addOi} onChange={(e) => setAddOi(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Agudeza Visual */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "8px" }}>
              <h4 style={{ fontWeight: "700", fontSize: "13px", marginBottom: "8px", textAlign: "center", color: "#007bff" }}>
                Agudeza Visual
              </h4>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ ...tableHeaderStyle, width: "50px" }}>Ojo</th>
                    <th style={tableHeaderStyle}>AV</th>
                    <th style={tableHeaderStyle}>CN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ ...tableCellStyle, fontWeight: "600", backgroundColor: "#e7f3ff" }}>OD</td>
                    <td style={tableCellStyle}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                        <span style={{ fontSize: "11px", fontWeight: "600" }}>20/</span>
                        <input 
                          type="number" 
                          step="0.25" 
                          min="0" 
                          max="400" 
                          value={avOd} 
                          onChange={(e) => setAvOd(e.target.value)} 
                          style={{ ...inputTablaOptometria, width: "45px" }} 
                          placeholder="" 
                        />
                      </div>
                    </td>
                    <td style={tableCellStyle}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                        <span style={{ fontSize: "11px", fontWeight: "600" }}>20/</span>
                        <input 
                          type="number" 
                          step="0.25" 
                          min="0" 
                          max="400" 
                          value={cvOd} 
                          onChange={(e) => setCvOd(e.target.value)} 
                          style={{ ...inputTablaOptometria, width: "45px" }} 
                          placeholder="" 
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ ...tableCellStyle, fontWeight: "600", backgroundColor: "#e7f3ff" }}>OI</td>
                    <td style={tableCellStyle}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                        <span style={{ fontSize: "11px", fontWeight: "600" }}>20/</span>
                        <input 
                          type="number" 
                          step="0.25" 
                          min="0" 
                          max="400" 
                          value={avOi} 
                          onChange={(e) => setAvOi(e.target.value)} 
                          style={{ ...inputTablaOptometria, width: "45px" }} 
                          placeholder="" 
                        />
                      </div>
                    </td>
                    <td style={tableCellStyle}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                        <span style={{ fontSize: "11px", fontWeight: "600" }}>20/</span>
                        <input 
                          type="number" 
                          step="0.25" 
                          min="0" 
                          max="400" 
                          value={cvOi} 
                          onChange={(e) => setCvOi(e.target.value)} 
                          style={{ ...inputTablaOptometria, width: "45px" }} 
                          placeholder="" 
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Retinoscopia */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "8px" }}>
              <h4 style={{ fontWeight: "700", fontSize: "13px", marginBottom: "8px", textAlign: "center", color: "#007bff" }}>
                Retinoscopia
              </h4>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={tableHeaderStyle}>OD</th>
                    <th style={tableHeaderStyle}>OI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={tableCellStyle}>
                      <input type="text" value={retinosOd} onChange={(e) => setRetinosOd(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="text" value={retinosOi} onChange={(e) => setRetinosOi(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Queratometría */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "8px" }}>
              <h4 style={{ fontWeight: "700", fontSize: "13px", marginBottom: "8px", textAlign: "center", color: "#007bff" }}>
                Queratometría
              </h4>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={tableHeaderStyle}>Ojo</th>
                    <th style={tableHeaderStyle}>Valor 1</th>
                    <th style={tableHeaderStyle}>Valor 2</th>
                    <th style={tableHeaderStyle}>Eje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ ...tableCellStyle, fontWeight: "600", backgroundColor: "#e7f3ff" }}>OD</td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={queratoOd1} onChange={(e) => setQueratoOd1(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={queratoOd2} onChange={(e) => setQueratoOd2(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={queratoOd3} onChange={(e) => setQueratoOd3(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ ...tableCellStyle, fontWeight: "600", backgroundColor: "#e7f3ff" }}>OI</td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={queratoOi1} onChange={(e) => setQueratoOi1(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={queratoOi2} onChange={(e) => setQueratoOi2(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                    <td style={tableCellStyle}>
                      <input type="number" step="0.25" min="-1000" max="1000" value={queratoOi3} onChange={(e) => setQueratoOi3(e.target.value)} style={inputTablaOptometria} placeholder="0.00" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Información Adicional */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto 1fr",
              gap: "15px",
              marginBottom: "20px",
              alignItems: "end",
            }}
          >
            <div style={{ maxWidth: "120px" }}>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                DI
              </label>
              <input
                type="text"
                value={diData}
                onChange={(e) => setDiData(e.target.value)}
                placeholder="Ingrese DI"
                style={{
                  border: "1px solid #ced4da",
                  padding: "6px",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "13px",
                }}
              />
            </div>
            <div style={{ maxWidth: "120px" }}>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                AO
              </label>
              <input
                type="text"
                value={aoData}
                onChange={(e) => setAoData(e.target.value)}
                placeholder="Ingrese AO"
                style={{
                  border: "1px solid #ced4da",
                  padding: "6px",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "13px",
                }}
              />
            </div>
            <div>
              <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "5px" }}>
                Lente de Contacto
              </label>
              <input
                type="text"
                value={lenteContactoDes}
                onChange={(e) => setLenteContactoDes(e.target.value)}
                placeholder="Descripción"
                style={{
                  border: "1px solid #ced4da",
                  padding: "6px",
                  borderRadius: "4px",
                  width: "70%",
                  fontSize: "13px",
                }}
              />
            </div>
          </div>

          {/* Fotos y Botón */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: "20px",
              alignItems: "end",
              marginTop: "20px",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
            }}
          >
            <div>
              <label htmlFor="foto" style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "8px" }}>
                Cargar Fotos
              </label>
              <input
                type="file"
                id="foto"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                style={{
                  width: "100%",
                  padding: "6px",
                  fontSize: "13px",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                }}
              />
              {fotos.length > 0 && (
                <p style={{ marginTop: "5px", fontSize: "12px", color: "#28a745", fontWeight: "500" }}>
                  {fotos.length} archivo(s) seleccionado(s)
                </p>
              )}
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                padding: "10px 30px",
                fontSize: "15px",
                fontWeight: "600",
                borderRadius: "6px",
                border: "none",
                backgroundColor: "#007bff",
                color: "white",
                cursor: "pointer",
                height: "fit-content",
              }}
            >
              {visitaSeleccionadaId ? "Actualizar Visita" : "Guardar Visita"}
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default Visita;
